import { call, put, select, takeLatest } from 'redux-saga/effects'
import PAYMENT_ORDER_API_V1 from 'api/payment-orders/v1'
import makeRedirectUrl from 'utils/makeRedirectUrl'

function* fetchPaymentOrderInfo({ payload, meta: { resolve, reject } }) {
  try {
    const { response, error } = yield call(
      PAYMENT_ORDER_API_V1.fetchPaymentOrderById,
      { id: payload.id },
    )

    if (error) {
      throw error
    }

    yield put({
      type: 'PAYMENT_ORDERS/SET_ORDER_INFO',
      payload: { ...response.data },
    })
    resolve(response.data)
  } catch (error) {
    reject()
    console.logXHR(error)
  }
}

function* fetchPayUrl({ payload, meta: { resolve, reject } }) {
  const { i18n } = yield select(({ app }) => app)

  try {
    const { response, error } = yield call(
      PAYMENT_ORDER_API_V1.fetchPaymentOrderLink,
      { id: payload.id },
    )

    if (error) {
      throw error
    }

    yield put({
      type: 'PAYMENT_ORDERS/SET_ORDER_INFO',
      payload: response.data,
    })

    const redirect_url = makeRedirectUrl({
      i18n,
      result_params: response.data.result_params,
    })

    resolve({ redirect_url, pay_url: response.data.pay_url })
  } catch (error) {
    reject()
    console.logXHR(error)
  }
}

export default function* Sagas() {
  yield takeLatest('PAYMENT_ORDERS/FETCH_INFO', fetchPaymentOrderInfo)
  yield takeLatest('PAYMENT_ORDERS/FETCH_PAY_URL', fetchPayUrl)
}
